/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

// You can delete this file if you're not using it
// import wrapWithProvider from "./src/wrap-with-provider";
// export const wrapRootElement = wrapWithProvider;
import "./src/styles/global.css"
import wrapWithProvider from "./src/components/Security/wrap-with-provider"
export const wrapRootElement = wrapWithProvider
